import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './utils/miscellaneous/prototypeExtensions.js';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/dist/locale-data/en';
import '@formatjs/intl-pluralrules/dist/locale-data/es';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HistoryRouter } from 'redux-first-history/rr6';
import App from './components/App.jsx';
import store, { history } from './store/appStore.js';
import { setLanguage } from '@actions/common/actionCreators';

const supportedLanguages = [ 'en', 'es', 'debug' ];
const handleLegacyMastheadLanguageChanged = event => {
    const requestedLanguage = event && event.detail && event.detail.language;
    if (!supportedLanguages.includes(requestedLanguage)) {
        return;
    }
    store.dispatch(setLanguage(requestedLanguage));
};

window.addEventListener('hix:language-changed', handleLegacyMastheadLanguageChanged);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <HistoryRouter history={history}>
            <App />
        </HistoryRouter>
    </Provider>
);
